<template>
  <div>
    <router-view v-if="ready"></router-view>
    <loading
      :active="!ready"
      color="#0061ad"
    >
    </loading>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'


export default {
  name: 'App',
  components: {
    Loading
  },
  computed: {
    ...mapState(['campaign', 'ready']),
  },
  methods: {
    ...mapActions([
      'getWorkbook',
      'loadCampaigns',
    ]),
  },
  mounted: function () {
    this.loadCampaigns();
    this.getWorkbook();

  },
}
</script>
